module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Blank Page"), _c('small', [_vm._v("It's all start from here "), _c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Common Page")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Login Page")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('el-dialog', {
    attrs: {
      "title": "Login",
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "visible": "false",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "account-box"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('a', {
    staticClass: "pull-right label-forgot",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Forgot email?")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "inputUsernameEmail"
    }
  }, [_vm._v("Username or email")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputUsernameEmail"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('a', {
    staticClass: "pull-right label-forgot",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Forgot password?")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputPassword"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkbox pull-left"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v("Remember me")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_c('router-link', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "to": "/"
    }
  }, [_vm._v(" Log In ")])], 1)]), _vm._v(" "), _c('a', {
    staticClass: "forgotLnk",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "or-box"
  }, [_c('center', [_c('span', {
    staticClass: "text-center login-with"
  }, [_vm._v("Login or "), _c('b', [_vm._v("Sign Up")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 row-block"
  }, [_c('a', {
    staticClass: "btn btn-facebook btn-block",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-facebook space-icon"
  }), _vm._v("Facebook")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 row-block"
  }, [_c('a', {
    staticClass: "btn btn-twitter btn-block",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-twitter space-icon"
  }), _vm._v("Twitter")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('div', {
    staticClass: "col-md-6 row-block"
  }, [_c('a', {
    staticClass: "btn btn-google btn-block",
    attrs: {
      "href": "#/profile"
    }
  }, [_c('span', {
    staticClass: "ti-google space-icon"
  }), _vm._v("Google +")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 row-block"
  }, [_c('a', {
    staticClass: "btn btn-instagram btn-block",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-instagram space-icon"
  }), _vm._v("Instagram")])])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 row-block"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Create New Account")])])])])])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e3b10464!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1032
// module chunks = 2